import { Controller } from "@hotwired/stimulus"

// Stops the spinner for app builds that never send native-download-finished.
const FALLBACK_MS = 30000

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.finish()
  }

  start() {
    this.iconTarget.classList.replace("fa-download", "fa-spinner")
    this.iconTarget.classList.add("fa-spin")
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.finish(), FALLBACK_MS)
  }

  finish() {
    clearTimeout(this.timeout)
    this.iconTarget.classList.replace("fa-spinner", "fa-download")
    this.iconTarget.classList.remove("fa-spin")
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
